import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { url } from 'src/config';
import { orgId } from 'src/constants';
import { alertSuccess, alertError } from './alert';
import moment from 'moment';
import { getBrowser, getOS, userLocation } from 'src/utils/getUserInfo';

let userIp = '',
  referrerUrl = '';
if (document.referrer)
  referrerUrl = document.referrer.match(/:\/\/(.[^/]+)/)[1];

userLocation().then((location) => {
  if (location) userIp = location.query;
});

const initialState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null,
  alreadyLoggedIn: false
};

const setUserStorage = (data) => {
  if (data) {
    let session_expiry = moment().add(1, 'days').valueOf();
    const current_store = JSON.stringify({
      current_vzid: btoa(data.userGlobalId),
      session_expiry
    });
    localStorage.setItem('current_store', current_store);
  } else {
    localStorage.removeItem('current_store');
  }
};

const isActiveTime = (session_expiry) => {
  if (!session_expiry) {
    return false;
  }

  const currentTime = moment().valueOf();

  return currentTime < session_expiry;
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.alreadyLoggedIn = false;
    },
    register(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.alreadyLoggedIn = false;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.alreadyLoggedIn = false;
    },
    fetchUser(state, action) {
      const { isAuthenticated, user, alreadyLoggedIn } = action.payload;

      state.isAuthenticated = isAuthenticated;
      state.isInitialised = true;
      state.user = user;
      state.alreadyLoggedIn = alreadyLoggedIn;
    },
    updateUserDetails(state, action) {
      state.user = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const login = (data) => async (dispatch) => {
  try {
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;

    const response = await axios.post(`${url}login/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;

    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    const { responseData } = response.data;
    setUserStorage(responseData);

    dispatch(slice.actions.login(responseData));
  } catch (err) {
    dispatch(alertError(err.message));
    return err;
  }
};

export const register = (data) => async (dispatch) => {
  try {
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}signup/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;

    if (responseCode === '00') {
      const { responseData } = response.data;
      setUserStorage(responseData);
      dispatch(slice.actions.register(responseData));
    }
    return responseMessage;
  } catch (err) {
    return 'Cannot not process at this time... Try again later';
  }
};

export const resetPassword = (data) => async () => {
  try {
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}resetpassword/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (err) {
    return 'Cannot not process at this time... Try again later';
  }
};

export const logout = () => (dispatch) => {
  setUserStorage(null);
  dispatch(slice.actions.logout());
};

export const forgotPassword = (data) => async (dispatch) => {
  try {
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}forgotpassword/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;

    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    if (responseCode === '00') {
      dispatch(alertSuccess(responseMessage));
    }
  } catch (err) {
    dispatch(alertError(err.message));
    return err;
  }
};

export const fetchUser = () => async (dispatch) => {
  try {
    const current_store = window.localStorage.getItem('current_store');
    const userBrowserType = getBrowser();
    const userIpAddress = userIp;
    const userDeviceType = getOS();
    const userRefererUrl = referrerUrl;
    if (current_store) {
      const { current_vzid, session_expiry } = JSON.parse(current_store);
      if (session_expiry && isActiveTime(session_expiry)) {
        const response = await axios.post(
          `${url}get-user-account-parameters/`,
          {
            userGlobalId: atob(current_vzid),
            // userGlobalId: 'VEZ58436311142',
            orgId,
            userBrowserType,
            userIpAddress,
            userDeviceType,
            userRefererUrl
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        );

        const { responseCode, responseMessage } = response.data;

        if (responseCode === '00') {
          const { responseData } = response.data;
          setUserStorage(responseData);
          dispatch(
            slice.actions.fetchUser({
              isAuthenticated: true,
              user: responseData,
              alreadyLoggedIn: true
            })
          );
        } else {
          dispatch(
            slice.actions.fetchUser({
              isAuthenticated: false,
              user: null,
              alreadyLoggedIn: false
            })
          );
        }
      } else {
        dispatch(
          slice.actions.fetchUser({
            isAuthenticated: false,
            user: null,
            alreadyLoggedIn: false
          })
        );
      }
    } else {
      dispatch(
        slice.actions.fetchUser({
          isAuthenticated: false,
          user: null,
          alreadyLoggedIn: false
        })
      );
    }
  } catch (err) {
    // dispatch(
    //   slice.actions.fetchUser({
    //     isAuthenticated: false,
    //     user: null,
    //     alreadyLoggedIn: false
    //   })
    // );
  }
};

// Change Password endpoint
export const changePassword = (data) => async (dispatch) => {
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.userGlobalId = atob(current_vzid);
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}change-user-password/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;
    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    if (responseCode === '00') {
      dispatch(alertSuccess(responseMessage));
    }
  } catch (err) {
    dispatch(alertError(err.message));
    return err;
  }
};

// Update User Details endpoint
export const updateUserDetails = (data) => async (dispatch) => {
  try {
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}update-user-profile/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;
    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    if (responseCode === '00') {
      dispatch(slice.actions.updateUserDetails(response.data.responseData));

      dispatch(alertSuccess(responseMessage));
    }
  } catch (err) {
    dispatch(alertError(err.message));
    return err;
  }
};

// Change user email endpoint
export const changeEmail = (data) => async (dispatch) => {
  try {
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}change-user-email/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;
    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    if (responseCode === '00') {
      dispatch(alertSuccess(responseMessage));
    }
  } catch (err) {
    dispatch(alertError(err.message));
    return err;
  }
};
export default slice;
